export default __webpack_public_path__ + "static/media/architecture-img-25.aa8693f7.jpg";